// utils/http.js
import axios from 'axios'
// import { Toast } from 'vant'
// import router from '@/router'  // 如果你用 Vue Router

import navigator from '@/common/navigator.js'
import notify from '@/common/notify.js'
import i18n from '@/i18n';
import { baseURL } from '@/config.js'

const instance = axios.create({
	baseURL,
	timeout: 5000,
	withCredentials: true
})

let showLoading = true

// 请求拦截器
instance.interceptors.request.use(
	config => {
		// console.log(config.data, 'config')
		const token = localStorage.getItem('token')
		if (token) {
			config.headers.token = token
		}
		config.headers.lang = localStorage.getItem('defaultLang') || 'en'

		//showLoading = config.data?.showLoading || config.params?.showLoading || true
		showLoading = config.data?.showLoading ?? config.params?.showLoading ?? true
		
		// console.log(showLoading)
		if (showLoading) {
			notify.showLoading()
		}
		return config
	},
	error => {
		if (showLoading) {
			notify.closeLoading()
		}
		notify.error(i18n.t('请求错误'))
		return Promise.reject(error)
	}
)

// 响应拦截器
instance.interceptors.response.use(
	response => {
		// console.log(typeof response.config.data, 'response')
		// if (showLoading) {
		notify.closeLoading()
		// }
		const data = response.data
		if (data.code != 1) {
			notify.error(data.msg)
		}
		return data
	},
	error => {
		// if (showLoading) {
		notify.closeLoading()
		// }
		const { response } = error
		if (response?.status === 401) {
			notify.error(i18n.t('登录失效，请重新登录'))
			localStorage.removeItem('token')
			setTimeout(() => {
				navigator.goLogin()
			}, 1000)
		} else if (response) {
			notify.error(response.data?.msg || `错误：${response.status}`)
		} else {
			// 没有 response，可能是超时或断网
			notify.error(i18n.t('网络错误，请检查连接'))
		}
		return Promise.reject(error)
	}
)

export default instance
